@if (show) {<span class="wrapper">eu</span>}